import React from 'react'

const ConsultBrief = () => (
  <>
  <h2 className="is-size-4">
    Consulting & Web Development
  </h2>

  <p>
    I'm currently doing both Elixir and Web Development consulting. Please get in
    contact with me and I'll happily discuss your needs and requirements with you.
  </p>
  <p>
    To see some of my Portfolio, please visit my GitHub or view the "Projects" section above.
  </p>
  <br />
  <p>Email me at: hello at tomh.uk</p>

  </>
)

export default ConsultBrief